export const check_ru = {
  title: "",
  description: "",
  progress_bar: "",
  phone: {
    label: "Телефон",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  }
};
export const check_kz = {
  title: "",
  description: "",
  progress_bar: "",
  phone: {
    label: "",
    complete_label: "",
    placeholder: "",
    desktop_tooltip: "",
    mobile_tooltip: ""
  }
};
